module.exports = __webpack_public_path__ + "img/miejsce-parkingowe.ee24fcb8.svg";